import {DateTime} from 'luxon'

/** Parse ISO 8601 formatted date string only in local time. */
export function parseIsoDate(value: string) {
  return DateTime.fromISO(value).toJSDate()
}

/** Parse ISO 8601 formatted date string only in local time or return date. */
export function safeParseIsoDate(value: string | Date) {
  return typeof value === 'string' ? parseIsoDate(value) : value
}
